import { api, setConfig } from '../..';
import { PropertyType } from '../../../common';

export const getPermissions = (data: PropertyType): Promise<PropertyType> =>
	api.get('/permissions', setConfig(data)).then((res) => {
		return res.data;
	});
